import React from "react";
import { RadioIcon } from "lucide-react";
import { useHackathon } from "../../contexts/HackathonContext";
import { demoCountdown } from "../../utils/dates";
import { toEmbedUrl } from "../../utils/judging";
import { subjectForGroup } from "../../utils/subjects";
import { useNow } from "../../hooks/useNow";
import { SectionHeading } from "./SectionHeading";
export function LiveSection() {
  const {
    state
  } = useHackathon();
  const cd = demoCountdown(useNow());
  return <section id="live" className="scroll-mt-20 bg-ink py-24 text-cream md:py-32" data-id="element-477" data-mp="3gr1c27teywr4">
      <div className="mx-auto max-w-[1400px] px-5 md:px-8" data-id="element-478" data-mp="3gsuns1ivw75z">
        <SectionHeading title="Watch live" tone="light" intro="All five final pitches stream here on October 13 from 2:00 PM PT. Each pitch is 5 minutes plus 3 minutes of investor Q&A." data-id="element-479" data-mp="3lpbcoxxwqpk4" />

        <div className="mt-16 grid gap-8 lg:grid-cols-[1fr_340px]" data-id="element-480" data-mp="111zs4rk28bxx">
          <div className="relative aspect-video overflow-hidden rounded-[28px] bg-sun" data-id="element-481" data-mp="15xnfr2iw8x1b">
            {state.streamUrl ? <>
                <iframe src={toEmbedUrl(state.streamUrl)} title="Demo Day livestream" className="absolute inset-0 h-full w-full" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowFullScreen data-id="element-482" data-mp="25m3svb6tc3ap" />
                <span className="absolute left-5 top-5 inline-flex items-center gap-1.5 rounded-full bg-tomato px-3 py-1 text-[12px] font-bold uppercase text-cream" data-id="element-483" data-mp="1mpc44m8i4vz9">
                  <RadioIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-484" data-mp="1hwsq5o5wjytx" />
                  Live
                </span>
              </> : <div className="absolute inset-0 flex flex-col items-center justify-center px-6 text-center text-ink" data-id="element-485" data-mp="18z0agiw9qp60">
                <RadioIcon className="h-8 w-8" aria-hidden="true" data-id="element-486" data-mp="13xt2oju4lpzc" />
                <p className="mt-4 font-display text-[clamp(3rem,8vw,6.5rem)] uppercase leading-none" data-id="element-487" data-mp="yzhsg7zx5dgl">
                  {cd.done ? "Starting soon" : `${cd.days}d ${cd.hours}h ${cd.minutes}m`}
                </p>
                <p className="mt-3 text-[13px] font-bold uppercase tracking-wide" data-id="element-488" data-mp="ucjng7u89faa">
                  Pitches stream live Tuesday, Oct 13 · 14:00 PT
                </p>
              </div>}
          </div>

          <div data-id="element-489" data-mp="ke3yobioai3y">
            <h3 className="text-[13px] font-bold uppercase tracking-wide text-sun" data-id="element-490" data-mp="kdko5fvcqvzy">Pitch order</h3>
            <ol className="mt-3 border-t border-cream/20" data-id="element-491" data-mp="183opthozclob">
              {state.pitchOrder.map((id, i) => {
              const profile = state.groups.find(g => g.id === id);
              return <li key={id} className="flex items-baseline gap-4 border-b border-cream/20 py-4" data-id="element-492" data-mp="yb0vqupdwvta" data-mpi={i}>
                    <span className="font-display text-3xl text-sun" data-id="element-493" data-mp="13a3trv6y61rr">{String(i + 1).padStart(2, "0")}</span>
                    <div className="min-w-0" data-id="element-494" data-mp="1qzy15x8hyy4m">
                      <p className="font-display text-2xl uppercase leading-tight" data-id="element-495" data-mp="1vtj1vx1h667i">
                        Team {String(id).padStart(2, "0")}
                        {profile?.productName && <span className="text-cream/60" data-id="element-496" data-mp="3bk359459kgae"> · {profile.productName}</span>}
                      </p>
                      <p className="truncate text-sm text-cream/60" data-id="element-497" data-mp="3q97sx0utvcpw">{subjectForGroup(id) ?? "Track to be announced"}</p>
                    </div>
                  </li>;
            })}
            </ol>
            <p className="mt-5 text-sm text-cream/60" data-id="element-498" data-mp="2xl3hrzthm7ft">Pitches are scored by an AI judge in real time; investors confirm the winners.</p>
          </div>
        </div>
      </div>
    </section>;
}